import { render, staticRenderFns } from "./MedicalContentInformation.vue?vue&type=template&id=8baa27ca&scoped=true&"
import script from "./MedicalContentInformation.vue?vue&type=script&lang=js&"
export * from "./MedicalContentInformation.vue?vue&type=script&lang=js&"
import style0 from "./MedicalContentInformation.vue?vue&type=style&index=0&id=8baa27ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baa27ca",
  null
  
)

export default component.exports